export const ART_PLACEHOLDER_MOBILE_URL = 'https://withjoy.com/assets/public/art-placeholder-mobile.png' as const;
